const ROOT = 'PAYMENT_METHOD_EDIT_DETAILS_ADD_BANK_ACCOUNT_';

const actions = {
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  ADD_BANK_ACCOUNT_REQUEST: `${ROOT}ADD_BANK_ACCOUNT_REQUEST`,
  ADD_BANK_ACCOUNT_SUCCESS: `${ROOT}ADD_BANK_ACCOUNT_SUCCESS`,
  ADD_BANK_ACCOUNT_ERROR: `${ROOT}ADD_BANK_ACCOUNT_ERROR`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  CHANGE_MODAL_VISIBILITY: `${ROOT}CHANGE_MODAL_VISIBILITY`,
  LOAD_FORM_INFO_REQUEST: `${ROOT}LOAD_FORM_INFO_REQUEST`,
  LOAD_FORM_INFO_SUCCESS: `${ROOT}LOAD_FORM_INFO_SUCCESS`,
  LOAD_FORM_INFO_ERROR: `${ROOT}LOAD_FORM_INFO_ERROR`,
  SETUP_INTENT_BANK_ACCOUNT_REQUEST: `${ROOT}SETUP_INTENT_BANK_ACCOUNT_REQUEST`,
  SETUP_INTENT_BANK_ACCOUNT_SUCCESS: `${ROOT}SETUP_INTENT_BANK_ACCOUNT_SUCCESS`,
  CONFIRM_BANK_ADDED_REQUEST: `${ROOT}CONFIRM_BANK_ADDED_REQUEST`,
} as const;

export default actions;
